import { createAsyncThunk } from "@reduxjs/toolkit";
import { refetchItemsInfoWithRestaurantId } from "../../../utils/APICalls/APICalls";

export const fetchItemStatusRedux = createAsyncThunk(
  "fetchItemStatusRedux",
  async (payload: { restaurantId: number; slug: string }) => {
    return await refetchItemsInfoWithRestaurantId(
      payload.restaurantId,
      payload.slug
    );
  }
);
